// @flow

import React, {useMemo, useState} from 'react';
import type {Skill, Resistance, Hero} from '../data/heroes.js';
import {Table, Input, Space, Button} from 'antd';

import data from '../data/heroes.js';
import type {Weapon} from '../data/heroes';
import {withRouter} from 'react-router';
import type {History, Match} from 'react-router';
import heroes from '../data/heroes.js';
import HeroProfileDialog from '../components/HeroProfileDialog';

type Props = {
  match: Match,
  history: History
};

function getColumns(history: History) {
  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      // eslint-disable-next-line react/display-name
      render: (name: string) => {
        return <Button
          type={'link'}
          onClick={() => history.replace('/heroes/' + name)}>
          {name}
        </Button>;
      },
    }, {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
    }, {
      title: 'Element',
      dataIndex: 'element',
      key: 'element',
    }, {
      title: 'Attack',
      dataIndex: 'atk',
      key: 'atk',
      defaultSortOrder: 'descend',
      sorter: (
        a: Hero,
        b: Hero,
      ) => {
        return a.atk - b.atk;
      },
    }, {
      title: 'HP',
      dataIndex: 'hp',
      key: 'hp',
      sorter: (
        a: Hero,
        b: Hero,
      ) => {
        return a.hp - b.hp;
      },
    }, {
      title: 'Defence',
      dataIndex: 'def',
      key: 'def',
    }, {
      title: 'Heal',
      dataIndex: 'heal',
      key: 'heal',
      sorter: (
        a: Hero,
        b: Hero,
      ) => {
        return a.heal - b.heal;
      },
    }, {
      title: 'Damage Reduction',
      dataIndex: 'damageReduction',
      key: 'damageReduction',
    }, {
      title: 'Critical Hit Chance',
      dataIndex: 'criticalHitChance',
      key: 'criticalHitChance',
    }, {
      title: 'Resistance',
      dataIndex: 'resistance',
      key: 'resistance',
      render: (resistance: Array<Resistance>) => {
        return resistance.map((res: Resistance, i: number) => {
          return <div key={i}>{`${res.type}: ${res.value * 100}%`}</div>;
        });
      },
    }, {
      title: 'Weapons',
      dataIndex: 'weapons',
      key: 'weapons',
      render: (weapons: Array<Weapon>) => {
        return weapons.map((weapon: Weapon, i: number) => {
          return <div key={i}>{weapon}</div>;
        });
      },
    }, {
      title: 'Card Slot',
      dataIndex: 'cardSlot',
      key: 'cardSlot',
    }, {
      title: 'Skills',
      dataIndex: 'skills',
      key: 'skills',
      render: (skills: Array<Skill>) => {
        return skills.map((skill: Skill, i: number) => {
          const target = skill.target === 'SELF' ? '' : `[${skill.target}]`;
          const content = `${target}${skill.attribute}: ${skill.value * 100}%`;
          return <div key={i}>{content}</div>;
        });
      },
    },
  ];
}


function Heroes({match, history}: Props) {
  const heroName = match.params.hero_name;
  const selectedHero = heroes.find((hero: Hero) => {
    return heroName != null && hero.name === heroName;
  });
  const [searchString, setSearchString] = useState<string>('');
  const filteredHero = useMemo(() => {
    return data.filter((hero: Hero) => {
      if (searchString === '') return true;
      return hero.name.toLowerCase().includes(searchString.toLowerCase());
    });
  }, [searchString]);
  return <Space direction={'vertical'}>
    <Input.Search
      placeholder="Search"
      value={searchString}
      onChange={(value: SyntheticInputEvent<HTMLInputElement>) => {
        setSearchString(value.target.value);
      }}
    />
    <Table columns={getColumns(history)} dataSource={filteredHero}/>
    <HeroProfileDialog
      hero={selectedHero}
      isVisible={selectedHero != null}
      onOK={() => {
        history.replace('/heroes');
      }}/>
  </Space>;
}

export default withRouter(Heroes);
